<div class="grid-header-container">
    <div class="grid-header-right" [class.show-header-controls]="showToolbar">
        <div class="additional-header-controls">
            <ng-content select="[additionalHeaderControls]"></ng-content>
        </div>
        <div class="grid-header-tools">
            <form class="select-jobs-filters-bar" [formGroup]="selectJobsFilterForm" *ngIf="allowJobStateFilter">
                <div class="cdp-filter-btn" [hcPop]="modeOptionsPop">
                    <span class="cdp-filter-btn-selection"
                        >Ingest mode:
                        <span class="cdp-filter-btn-selection-val">{{
                            selectJobsFilterForm.value.ingestMode || 'Any'
                        }}</span></span
                    >
                    <span class="icon-right icon-chev-down"></span>
                </div>

                <hc-pop #modeOptionsPop [showArrow]="false" horizontalAlign="start">
                    <div class="cdp-filter-pop-options">
                        <div
                            #moduleOption
                            tabindex="0"
                            class="cdp-filter-pop-option"
                            [class.selected-option]="!selectJobsFilterForm.value.ingestMode"
                            (click)="selectMode('')"
                            title="Any ingest mode"
                        >
                            <span class="cdp-filter-pop-option-name">
                                <span class="cdp-filter-pop-option-name-inner">Any</span>
                            </span>
                        </div>
                        <ng-container *ngFor="let option of rawModeOptions">
                            <div
                                #moduleOption
                                tabindex="0"
                                class="cdp-filter-pop-option"
                                [class.selected-option]="option.name === selectJobsFilterForm.value.ingestMode"
                                (click)="selectMode(option.name)"
                                [title]="option.help"
                            >
                                <span class="cdp-filter-pop-option-name">
                                    <span class="cdp-filter-pop-option-name-inner">{{ option.name }}</span>
                                </span>
                            </div>
                        </ng-container>
                    </div>
                </hc-pop>
                <hc-checkbox tight="true" formControlName="filterToOnlyActiveJobs">Only show active jobs</hc-checkbox>
            </form>
            <cdp-grid-col-menu
                #colMenu
                [gridSettingsStorageKey]="gridSettingsStorageKey"
                [availableDataCols]="gridCols"
                [staticPrefixCols]="staticPrefixColumns"
                [staticSuffixCols]="staticSuffixColumns"
            ></cdp-grid-col-menu>
            <hc-search-bar
                #jobsSearch
                placeholder="Search..."
                [autoSearch]="true"
                (triggerSearch)="search($event)"
            ></hc-search-bar>
        </div>
    </div>
</div>
<cdp-grid-states
    [nameSingular]="nameSingular"
    [namePlural]="namePlural"
    [emptyMsg]="emptyMsg"
    [allowAddNew]="false"
    [loading]="loading"
    [loadFailed]="loadingError"
    [dataSource]="dataSource"
    [searchValue]="jobsSearch.value"
    [noColsSelected]="colMenu.allHidden"
    (clearSearch)="jobsSearch.clear()"
    (selectCols)="colMenu.open()"
    (refresh)="refreshRequested.emit()"
>
</cdp-grid-states>

<cdp-grid-bulk-actions
    [hideRowCount]="true"
    [forceSelectAllMessage]="true"
    [dataSource]="dataSource"
></cdp-grid-bulk-actions>
<!-- Grid -->
<div [hidden]="dataSource.filteredData.length === 0 || colMenu.allHidden || loading" class="cdp-grid-container">
    <table
        #table
        hc-table
        [class.cdp-grouped-rows-table]="entityCount > 1"
        [tight]="true"
        [dataSource]="dataSource"
        [borders]="false"
        cdkDropList
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="colMenu.columnDropped($event)"
    >
        <ng-container *ngFor="let column of gridCols" [hcColumnDef]="column.key">
            <th
                hc-header-cell
                *hcHeaderCellDef
                cdkDrag
                [cdkDragData]="{ key: column.key }"
                class="draggable-header"
                title="Drag to rearrange columns"
            >
                <span class="icon-grip"></span>
                {{ column.title }}
            </th>
            <td hc-cell *hcCellDef="let element">
                <ng-container [ngSwitch]="column.key">
                    <span *ngSwitchCase="'job'" class="job-num-indicator">
                        <span class="icon-toolbox icon-left job-ico"></span>
                        <span [innerHTML]="element.job | highlight: searchTerm"></span>
                    </span>
                    <div *ngSwitchCase="'activeFlag'" class="active-job-toggle" (click)="$event.stopPropagation()">
                        <hc-slide-toggle
                            *ngIf="allowJobStateTogglePerRow"
                            [cdpHasUserPermissions]="['sources.edit']"
                            title="{{ element.activeFlag ? 'Deactivate' : 'Activate' }} this job"
                            [buttonState]="element.activeFlag"
                            (click)="onActiveFlagToggle(element)"
                            [insideLabel]="'none'"
                            [disabled]="jobChangeInProgress"
                        ></hc-slide-toggle>
                        <cdp-active-status-display [isActive]="element.activeFlag"></cdp-active-status-display>
                    </div>
                    <span *ngSwitchCase="'ingestMode'">
                        <cdp-job-chip
                            [mode]="element.ingestMode"
                            [jobId]="element.ingestionId"
                            [isActive]="element.activeFlag"
                            [search]="jobsSearch.value"
                        >
                        </cdp-job-chip>
                    </span>
                    <cdp-grid-cell
                        *ngSwitchDefault
                        [element]="element"
                        [column]="column"
                        [isDisabled]="element.unselectable || (!allowInactiveJobSelection && !element.activeFlag)"
                        [searchTerm]="jobsSearch.value"
                    >
                    </cdp-grid-cell>
                </ng-container>
            </td>
        </ng-container>

        <ng-container hcColumnDef="checkbox">
            <th hc-header-cell *hcHeaderCellDef>
                <hc-checkbox
                    [tight]="true"
                    (change)="onMasterCheckboxClicked($event)"
                    (click)="$event.stopPropagation()"
                    [checked]="bulkActions.allChecked || false"
                    [indeterminate]="bulkActions?.masterCheckboxIsIndeterminate || false"
                    [disabled]="jobChangeInProgress"
                ></hc-checkbox>
            </th>
            <td
                hc-cell
                *hcCellDef="let element"
                [title]="allowInactiveJobSelection ? 'Click to select/deselect row' : 'Cannot select inactive jobs'"
            >
                <hc-checkbox
                    #check
                    [tight]="true"
                    [disabled]="
                        jobChangeInProgress ||
                        element.unselectable ||
                        (!allowInactiveJobSelection && !element.activeFlag)
                    "
                    (change)="toggleSelectItem($event, element)"
                    (click)="$event.stopPropagation()"
                    [checked]="element.isSelected || false"
                    class="{{ element.valid ? '' : 'invalid-checkbox' }}"
                ></hc-checkbox>
            </td>
        </ng-container>

        <ng-container hcColumnDef="info">
            <th hc-header-cell *hcHeaderCellDef></th>
            <td hc-cell *hcCellDef="let element">
                <span class="icon-info cdp-info-ico" [hcPop]="jobInfo" [context]="element"></span>
            </td>
        </ng-container>

        <tr hc-header-row *hcHeaderRowDef="colMenu.displayedColumns"></tr>
        <tr
            hc-row
            *hcRowDef="let row; columns: colMenu.displayedColumns"
            class="{{ row.rowGroupOrdinal % 2 === 0 ? 'row-color' : 'row-color-alt' }}"
            [class.hc-action-row]="isRowClickable(row)"
            (click)="onRowClick(row)"
        ></tr>
    </table>
</div>
<hc-pagination
    #paginator
    [class.show-pagination]="dataSource.data.length > pageSize"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    displayWidth="md"
>
</hc-pagination>

<hc-pop #jobInfo (opened)="infoPopItem = $event">
    <div class="entity-info-pop">
        <div class="entity-info-pop-header">
            <div [class.hc-font-em]="!infoPopItem?.entityId || infoPopItem?.entityId === -1">
                <span class="icon-table"></span>
                {{ infoPopItem?.entityName || 'Unnamed Entity' }}
            </div>
            <cdp-job-chip
                *ngIf="infoPopItem"
                [mode]="infoPopItem?.ingestMode"
                [jobId]="infoPopItem?.ingestionId"
                [isActive]="infoPopItem?.activeFlag"
            >
            </cdp-job-chip>
        </div>
        <div class="entity-info-section">
            <div><label>Schedule:</label> {{ infoPopItem?.scheduleDescription }}</div>
            <div><label>Ingest Mode:</label> {{ infoPopItem?.ingestMode }}</div>
            <div><label>Batch Size:</label> {{ infoPopItem?.batchSize || '-' }}</div>
            <div><label>Watermark Key:</label> {{ infoPopItem?.watermarkKey || '-' }}</div>
            <div><label>Watermark Value:</label> {{ infoPopItem?.watermarkValue || '-' }}</div>
            <div><label>Backfill Minimum:</label> {{ infoPopItem?.backfillMinimum || '-' }}</div>
            <div><label>Source:</label> {{ infoPopItem?.source }}</div>
        </div>
    </div>
</hc-pop>
